import PropTypes from 'prop-types';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';

const isExternalHref = (href) =>
  href?.startsWith('http://') || href?.startsWith('https://');

const HomepageAlertBody = ({
  text = '',
  href,
  openInNewTab = false,
  editPreview = false,
}) => {
  const trimmed = (text || '').trim();
  const link = (href || '').trim();

  if (!trimmed) {
    if (!editPreview) {
      return null;
    }

    return (
      <div className="warning-message">
        <p className="warning-message-text">
          Avís (sense text — no es mostrarà als visitants)
        </p>
      </div>
    );
  }

  const content = <p className="warning-message-text">{trimmed}</p>;

  return (
    <div className="warning-message">
      {link ? (
        <UniversalLink
          href={link}
          openLinkInNewTab={openInNewTab || isExternalHref(link)}
        >
          {content}
        </UniversalLink>
      ) : (
        content
      )}
    </div>
  );
};

HomepageAlertBody.propTypes = {
  text: PropTypes.string,
  href: PropTypes.string,
  openInNewTab: PropTypes.bool,
  editPreview: PropTypes.bool,
};

const View = ({ data, className, editPreview = false }) => {
  const trimmed = (data.text || '').trim();
  if (!trimmed && !editPreview) {
    return null;
  }

  return (
    <div className={className}>
      <HomepageAlertBody
        text={data.text}
        href={data.href}
        openInNewTab={data.openInNewTab}
        editPreview={editPreview}
      />
    </div>
  );
};

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  className: PropTypes.string,
  editPreview: PropTypes.bool,
};

export default withBlockExtensions(View);
export { HomepageAlertBody };
